// extracted by mini-css-extract-plugin
module.exports = {"FacebookLogin":"styles_FacebookLogin__eod2p","FacebookLogin-btn":"styles_FacebookLogin-btn__xUQ5g"};